export default {
  ALERT: {
    CONFIRM: 'return',
    CANCEL: 'esc'
  },
  MODE_SWITCHER: {
    EDIT_MODE: 'e',
    DISCUSS_MODE: 'd',
    VIEW_MODE: 'v'
  },
  BOARD: {
    TOGGLE_HIDE_GRID: 'g',
    PLACE_TEXT: 't',
    PLACE_COLOR: ['r', 'c'], // r for rectangle
    CANCEL_PLACEMENT: 'esc', // exit text/color placement mode
    PASTE_BLOCKS: 'mod+v',
    PASTE_BLOCKS_IN_PLACE: 'mod+shift+v',
    UNDO: 'mod+z',
    REDO: ['mod+shift+z', 'mod+y'],
    SELECT_ALL: 'mod+a'
  },
  BLOCK: {
    PREVIOUS: 'left',
    NEXT: 'right'
  },
  SELECTABLE: {
    // Groups and ungrouped individual blocks are collectively known as 'Selectables'
    DELETE: ['backspace', 'del'],
    SEND_BACK: 'mod+[',
    SEND_FORWARD: 'mod+]',
    SEND_TO_BACK: 'mod+shift+[',
    SEND_TO_FRONT: 'mod+shift+]',
    // MOVE_TO_QUEUE: 'q',
    // COPY_TO_QUEUE: 'shift+q',
    // COPY_BLOCKS: 'mod+c',
    MOVE_LEFT: 'left',
    MOVE_RIGHT: 'right',
    MOVE_UP: 'up',
    MOVE_DOWN: 'down',
    MOVE_LEFT_1: 'shift+left',
    MOVE_RIGHT_1: 'shift+right',
    MOVE_UP_1: 'shift+up',
    MOVE_DOWN_1: 'shift+down',
    // MAKE_BIGGER: 'b',
    // MAKE_SMALLER: 's',
    DESELECT: 'mod+d'
  },
  GROUP: {
    GROUP: 'mod+g' // toggle
  },
  QUEUE: {
    PREVIOUS: 'left',
    NEXT: 'right',
    INCREASE_COLS: ['up', '='],
    DECREASE_COLS: ['down', '-'],
    CLOSE_QUEUE: 'esc'
  },
  DISCUSS: {
    NEW_THREAD: 'c',
    POST_COMMENT: 'mod+return',
    CANCEL_COMMENT: 'esc'
  },
}
